"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var DayPartCell = /** @class */ (function (_super) {
    tslib_1.__extends(DayPartCell, _super);
    function DayPartCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseDown = function (e) {
            var _a = _this.props, day = _a.day, hour = _a.hour, onCellMouseDown = _a.onCellMouseDown;
            onCellMouseDown(day, hour, !_this.props.selected);
        };
        _this.onMouseOver = function (e) {
            var _a = _this.props, day = _a.day, hour = _a.hour, onCellMouseOver = _a.onCellMouseOver;
            onCellMouseOver(day, hour, e);
        };
        _this.onMouseUp = function (e) {
            var onCellMouseUp = _this.props.onCellMouseUp;
            onCellMouseUp(e);
        };
        return _this;
    }
    DayPartCell.prototype.render = function () {
        var _a;
        var _b = this.props, day = _b.day, hour = _b.hour, selected = _b.selected, className = _b.className, theme = _b.theme;
        var classes = classnames_1.default(theme.cell, className, (_a = {},
            _a[theme.selected] = selected,
            _a));
        return (React.createElement("td", { className: classes, onMouseDown: this.onMouseDown, onClick: this.onMouseOver, onMouseOver: this.onMouseOver, onMouseUp: this.onMouseUp }));
    };
    DayPartCell.defaultProps = {
        onCellMouseDown: utils_1.noop,
        onCellMouseOver: utils_1.noop,
        onCellMouseUp: utils_1.noop,
        selected: false
    };
    DayPartCell.contextTypes = {};
    return DayPartCell;
}(React.Component));
exports.default = DayPartCell;
